module.exports = __webpack_public_path__ + "img/playbook-preview.79dfb209.png";